import { Directive, Input } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { Offer } from "@models";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { Tradable } from "@models/interfaces/tradable";
import { TRADE_TYPE } from "@models/trade-offer.model";
import { AccountService } from "../../account/services/account.service";
import { SavingsService } from "@main-services/savings.service";
import { UserService } from "@main-services/user.service";
import { TradeSavingsComponent } from "../../trade/modals/trade-savings-modal/trade-savings-modal.component";
import { TOKEN_BEST_ID } from "@helpers/constants";
import { Best2TermsModalComponent } from "../../trade/modals/best-2-terms-modal/components/best-2-terms-modal.component";
import { StockTestService } from "@main-services/stock-test.service";
import { StockTestHelperService } from "@main-services/stock-test-helper.service";
import { UntilDestroy } from "@ngneat/until-destroy";

@UntilDestroy()
@Directive()
export abstract class SavingsHandlerComponent {
	@Input() public tradable: Tradable = null;

	protected constructor(
		protected tradableWalletListService: TradableWalletListService,
		protected modalService: ModalService,
		protected savingsService: SavingsService,
		protected accountService: AccountService,
		protected userService: UserService,
		protected stockTestService: StockTestService,
		protected stockTestHelperService: StockTestHelperService
	) {}

	public triggerNewSavingsPlan(offer: Offer = new Offer()): void {
		const callback: Function = () => this.addNewSavingsPlan(offer);
		if (!!this.tradable && !this.userService.user.isUnverified()) {
			const wallet = this.tradableWalletListService
				.getWalletsByTradableId(this.tradable.getId())
				.find((w) => w.isDefault());

			if (this.stockTestService.needsTest(wallet.getCurrencyId())) {
				this.stockTestHelperService.startTest(callback);
			} else {
				callback();
			}
		} else {
			callback();
		}
	}

	public addNewSavingsPlan(offer: Offer = new Offer()): void {
		offer.setType(TRADE_TYPE.RECURRING_BUY);

		if (!!this.tradable && !this.userService.user.isUnverified()) {
			offer.setCurrencyId(this.tradable.getId());
			offer.setWalletId(
				this.tradableWalletListService
					.getWalletsByTradableId(this.tradable.getId())
					.find((w) => w.isDefault())
					.getId()
			);

			if (this.tradable.getId() === TOKEN_BEST_ID && this.accountService.showBest2TermsOnBestTrade()) {
				this.handleBest2Terms();
				return;
			}
		}

		const modal = this.modalService.create(TradeSavingsComponent, { data: offer });
		this.modalService.pop();
		modal.present();
	}

	// global disable in case of maintenance for all savings sections
	public get savingsDisabled(): boolean {
		return this.accountService.account.getSavingsDisabled();
	}

	public userHasSavingsPlan(isWidget: boolean = false): boolean {
		return this.savingsService.getUserHasSavingsPlan(isWidget);
	}

	// TODO: Remove after 03.01.2022
	public handleBest2Terms(): void {
		const best2TermsModal = this.modalService.create(Best2TermsModalComponent, null, { showBackdrop: false });
		best2TermsModal.present();
		best2TermsModal.onDismiss.subscribe((res) => {
			if (res.data === "accepted") {
				this.addNewSavingsPlan();
			}
		});
	}
}
